<template>
    <el-dialog
      title="打开微信“扫一扫”，打开网页后点击屏幕右上角分享按钮"
      :visible="visible"
      @close="() => {visible=false; this.closeEvent()}"
      width="30%"
      class="ue-qr"
      >
      <canvas id="qr"></canvas>
    </el-dialog>
</template>
<script>
import QRCode from 'qrcode'
export default {
  name: 'qr',
  data () {
    return {
      visible: false
    }
  },
  methods : {
    init () {
      this.$nextTick(() => {
         QRCode.toCanvas(document.querySelector('#qr'), location.href.split('com')[0] , function (error) {
        })
      })
    }
  }
}
</script>
<style lang="scss">
.ue-qr {
  canvas {
    margin: auto;
  }
}
.el-dialog__body {
  text-align: center !important;
}
.el-dialog__header {
  padding: 35px 30px 10px !important;
}
</style>


